<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="用户搜索："  label-for="key">
              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
                <Select v-model="field_key" slot="prepend" style="width: 80px" @on-change="selectChange">
                  <Option value="all">全部</Option>
                  <Option value="phone">手机号</Option>
                  <Option value="nickname">用户名称</Option>
                </Select>
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <Tag color="blue" v-if="row.status==0">待审核</Tag>
          <Tag color="purple" v-else-if="row.status==1" >审核通过</Tag>
          <Tag color="gold" v-else-if="row.status==2">拒绝</Tag>
        </template>
        <template slot-scope="{ row, index }" slot="type">
          <Tag v-if="row.type==1" >微信</Tag>
          <Tag v-else-if="row.type==2">银行卡</Tag>
          <Tag v-else-if="row.type==3">支付宝</Tag>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div v-if="row.status==0">
            <a @click="comfirm(row)">审核</a>
          </div>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <withdrawEdit ref="withdrawEdit" :editShow="editShow" :id="withdraw_id" @updateStatusModel="updateStatusModel"></withdrawEdit>
  </div>
</template>

<script>
import { withdrawList } from '@/api/withdraw'
import withdrawEdit from './components/withdrawEdit'
export default {
  name: 'withdrawList',
  components: { withdrawEdit },
  inject: ['reload'],
  data () {
    return {
      confirm: false,
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        field_key: ''
      },
      withdraw_sn: '',
      editShow: false,
      withdraw_id: 0,
      dataCount: 0,
      field_key: 'all',
      userInfo: [],
      loading: false,
      columns2: [
        {
          title: '用户名称',
          key: 'nickname',
          minWidth: 120
        },
        {
          title: '手机号',
          key: 'phone',
          minWidth: 120
        },
        {
          title: '提现订单编号',
          key: 'withdraw_sn',
          minWidth: 120
        },
        {
          title: '提现金额',
          key: 'money',
          minWidth: 120
        },
        {
          title: '提现方式',
          slot: 'type',
          minWidth: 120
        },
        {
          title: '真实姓名',
          key: 'realName',
          minWidth: 120
        },
        {
          title: '银行名称',
          key: 'bankName',
          minWidth: 120
        },
        {
          title: '银行卡号',
          key: 'cardNo',
          minWidth: 120
        },
        {
          title: '状态',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '拒绝理由',
          key: 'remark',
          minWidth: 120
        },
        {
          title: '申请时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.recList()
  },
  methods: {
    recList () {
      this.loading = true
      this.userForm.field_key = this.field_key === 'all' ? '' : this.field_key
      withdrawList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.recList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.recList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    comfirm (row) {
      this.withdraw_id = row.withdraw_id
      this.editShow = true
    },
    closeModal (val) {
      if (val) {
        this.reload()
      }
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    }
  }
}
</script>
